/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import TokenDecoder from 'src/helpers/TokenDecoder';
import data from '@iconify/icons-eva/plus-fill';

export default {
    getUserByID,
    ChangePassword
};

async function getUserByID(userID) {
    const response = await CommonGet('/api/User/getUserDetailsByID', 'userID=' + parseInt(userID));
    return response.data;
}

async function ChangePassword(data, userName) {
    let Changemodel = {
        UserID: parseInt(TokenDecoder.getUserIDFromToken()),
        UserName: userName,
        UserOldPassword: data.oldPassword,
        UserNewPassword: data.newPassword,
        UserConfirmPassword: data.confirmPassword
    }
    const response = await CommonPost('/api/Auth/ChangePassword', null, Changemodel);
    return response;
}